<template>
  <LoadingIndicator>
    <div>
      <b-modal :title="$t('order.importList')" v-model="openCellsList" ok-only @ok="primarMapBoosterByList">
        <b-form-textarea v-model="cellList" :placeholder="$t('order.pastList')" />
      </b-modal>
  
      <!-- Заказ формируется -->
      <div v-if="!orderPlaced" class="mt-1">
        <b-row class="align-items-center">
          <b-col cols="auto" class="d-flex align-items-center">
            <!-- Переключатель периода покупки карт -->
            <PeriodStepper :selected-period="selectedPeriod" :period-options="periodOptions"
              @period-changed="onPeriodChanged" />
          </b-col>
  
          <!-- Кнопки -->
          <b-col class="d-flex justify-content-end align-items-center">
            <ActionButtons :area-selection-active="areaSelectionActive" :has-active-route="hasActiveRoute"
              :is-empty-cart="isEmptyCart()" @import-clipboard="importClipboard"
              @toggle-area-selection="toggleAreaSelection" @select-charts-by-route="selectChartsByRoute"
              @clear-cart="clearCart" />
          </b-col>
        </b-row>
  
        <!-- Отдельная строка для кнопок Get price / Submit / Update -->
        <b-row class="mt-1">
          <b-col>
            <OrderActions :has-total-price="hasTotalPrice()" :is-empty-cart="isEmptyCart()"
              :is-edit-mode="viewParent.editMode" :display-total-price="getDisplayTotalPrice()"
              :agreement-name="deviceStore.getAgreementName" @calculate-cart="calculateCart" @place-order="placeOrder"
              @update-order="updateOrder" />
          </b-col>
        </b-row>
  
        <!-- Фильтры ячеек по бендам -->
        <b-row class="mt-1">
          <b-col>
            <BandFilters v-if="cartStore.getCartLength > 0" v-model="bandFilters" @change="onBandFiltersChanged" />
          </b-col>
        </b-row>
  
        <!-- Корзина ENC -->
        <CartTable v-if="!orderPlaced" ref="orderstable" :items="visibleCellsRows()" :fields="visible_cells_fields"
          :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :is-purchased-early="purchasedEarly"
          :get-cell-valid-date="getCellValidDate" :is-newly-added="isNewlyAdded" :is-complex-product="isComplexProduct"
          :get-band-name="bandName" :get-cell-by-id="cellById" :get-cell-display-price="getCellDisplayPrice"
          :get-row-class="getRowClass" @row-selected="onRowSelected" @toggle-cell-inclusion="toggleCellInclusion" />
      </div>
  
      <!-- Блок подтверждения заказа -->
      <OrderSummary v-if="orderPlaced" :agreement-name="deviceStore.getAgreementName" :ship-name="userStore.getShipName"
        :agreement-provider="deviceStore.getAgreementProvider" :enabled-items-count="currentCartEnabledItemsLen"
        :display-period="getDisplayPeriod()" :display-total-price="getDisplayTotalPrice()"
        :preparing-cells="preparingCells" :is-edit-mode="viewParent.editMode" @cancel-order="cancelOrder"
        @approve-order="approveOrder" />
    </div>
  </LoadingIndicator>
</template>

<script>
import dayjs from "dayjs";
import { eventBus } from "@/main";
import * as utils from "@/utils/utils";
import { myAxios } from "@/services/myAxios";
import router from "@/router";
import { mapStores } from "pinia";
import { useRoutesStore } from "@/stores/routes";
import { useMomentaryStore } from "@/stores/momentary";
import { useDeviceStore } from "@/stores/device";
import { useUserStore } from "@/stores/user";
import { sendPurchaseRequest, sendStripePaymentRequest, sendUpdateRequest, loadDatasetByLegs, getMapsByArea } from "@/helpers/api";
import { useCartStore } from "@/stores/cart";
import { useCatalogsStore } from "@/stores/catalogs";
import { useCatalogStore } from "@/stores/catalog";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import BandFilters from './components/BandFilters.vue';
import PeriodStepper from './components/PeriodStepper.vue';
import ActionButtons from './components/ActionButtons.vue';
import OrderActions from './components/OrderActions.vue';
import CartTable from './components/CartTable.vue';
import OrderSummary from './components/OrderSummary.vue';

export default {
  name: "OrdersTable",
  components: {
    LoadingIndicator,
    BandFilters,
    PeriodStepper,
    ActionButtons,
    OrderActions,
    CartTable,
    OrderSummary
  },
  // Объект с методами родительского компонента
  props: {
  },
  data() {
    return {
      sortBy: null, // отключена сортировка по умолчанию
      sortDesc: false,
      filterSelectAll: false,
      filterAll: false,
      filterOVR: false,
      filterGNR: false,
      filterCST: false,
      filterAPR: false,
      filterHRB: false,
      filterBRG: false,

      preparingCells: false,
      orderPlaced: false,
      viewParent: this.$parent.$parent.$parent.$parent,
      availablePeriods: ["4", "1", "0"],
      selectedPeriod: "4",
      priceCalculating: false,
      openCellsList: false,
      cellList: "",
      // Флаги для отслеживания изменений корзины
      cartModified: false,
      // Состояние инструмента выбора области
      areaSelectionActive: false,
      areaSelectionToastId: null,
      // Для анимации новых ячеек
      newlyAddedCells: new Set(), // Множество ID недавно добавленных ячеек
      cellAnimationTimeouts: new Map(), // Таймеры для очистки анимации
    };
  },
  mounted() {
    // Загружаем fallback данные для проверки купленных карт
    this.loadPrimarChartsDataForOrders();

    eventBus.$on("toggle-chart-from-graph", (id) => {
      this.toggleCellInclusion(id, "switch");
    });

    eventBus.$on("update-available-periods", (periods) => {
      this.availablePeriods = periods;
      console.log("OrdersTable: update-available-periods", periods);
    });

    // Поддержка маршрутов - слушаем обновления периодов из карты
    if (this.hasActiveRoute) {
      eventBus.$on("route-periods-updated", (periods) => {
        this.availablePeriods = periods;
        console.log("OrdersTable: route periods updated", periods);
      });

      // Слушаем события выбора ячеек на карте для маршрутов
      eventBus.$on("highlight-onroute-cell", (cellName) => {
        this.onCellClicked(cellName);
      });
    }

    eventBus.$on("make-row-active", (id) => {
      this.onCellClicked(id);
    });

    // Слушаем событие добавления карт по маршруту
    eventBus.$on("add-charts-by-route", async (cellsList) => {
      console.log("OrdersTable: add-charts-by-route:", cellsList.length, "maps");
      // Используем наш универсальный метод для добавления карт
      // append: true так как корзина НЕ очищается в selectChartsByRoute
      await this.addCellsToCartAndMap(cellsList, true);
    });

    // Слушаем событие добавления одиночной ячейки при клике по карте
    eventBus.$on("cell-added-to-cart", (cellId) => {
      console.log("🎨 Single cell added to cart:", cellId);
      // Анимируем новую ячейку
      this.markCellsAsNew([cellId]);
    });

    // Ячейка не найдена - обработка для других случаев (не импорт)
    eventBus.$on("cell-not-found", (id) => {
      console.log("Cell not found:", id);
      // Для импорта ячеек статистика обрабатывается в store
      // Этот обработчик остается для совместимости с другими функциями
    });

    // Слушаем событие сброса цены от карты при переключении ячейки через клик
    eventBus.$on("reset-total-price-if-needed", () => {
      console.log("OrdersTable: reset-total-price-if-needed event received");
      this.resetTotalPriceIfNeeded();
    });

  },
  beforeDestroy() {
    // Очищаем все таймеры анимации при уничтожении компонента
    this.clearAllCellAnimations();

    eventBus.$off("make-row-active");
    eventBus.$off("toggle-chart-from-graph");
    eventBus.$off("update-available-periods");
    eventBus.$off("route-periods-updated");
    eventBus.$off("highlight-onroute-cell");
    eventBus.$off("add-charts-by-route");
    eventBus.$off("cell-not-found");
    eventBus.$off("reset-total-price-if-needed");
  },
  watch: {
    periodOptions(newOptions, oldOptions) {
      if (oldOptions.length > 0) {
        const isSelectedPeriodAvailable = newOptions.some((option) => option.value === this.selectedPeriod);
        if (!isSelectedPeriodAvailable && newOptions.length > 0) {
          this.selectedPeriod = newOptions[0].value;
        }
      }
    },
    "cartStore.getCartLength"(newVal, oldVal) {
      console.log("📊 [ORDERS TABLE] cartStore.getCartLength changed from", oldVal, "to", newVal);
      console.log(
        "📊 [ORDERS TABLE] Current cart:",
        this.cartStore.getCart.map((item) => item.id)
      );
      // При изменении количества товаров - сбрасываем общую цену
      this.resetTotalPriceIfNeeded();
      this.checkOrdersHistory();
    },
    selectedPeriod() {
      // При изменении периода - сбрасываем все цены
      this.resetTotalPriceIfNeeded();
    },
  },
  computed: {
    ...mapStores(useRoutesStore, useMomentaryStore, useUserStore, useDeviceStore, useCartStore, useCatalogsStore, useCatalogStore),

    // Computed свойство для работы с BandFilters компонентом
    bandFilters: {
      get() {
        return {
          filterAll: this.filterAll,
          filterOVR: this.filterOVR,
          filterGNR: this.filterGNR,
          filterCST: this.filterCST,
          filterAPR: this.filterAPR,
          filterHRB: this.filterHRB,
          filterBRG: this.filterBRG
        };
      },
      set(value) {
        this.filterAll = value.filterAll;
        this.filterOVR = value.filterOVR;
        this.filterGNR = value.filterGNR;
        this.filterCST = value.filterCST;
        this.filterAPR = value.filterAPR;
        this.filterHRB = value.filterHRB;
        this.filterBRG = value.filterBRG;
      }
    },

    periodOptions() {
      const allOptions = [
        { value: "4", text: "3 m." },
        { value: "1", text: "6 m." },
        { value: "0", text: "12 m." },
      ];
      return allOptions.filter((option) => this.availablePeriods.includes(option.value));
    },
    currentCartEnabledItemsLen() {
      // const enabledItems = this.$store.state.current.cart.s63cells.filter(function (e) {
      const enabledItems = this.cartStore.getCart.filter(function (e) {
        return !e.disabled;
      });
      return enabledItems.length;
    },
    hasActiveRoute() {
      return this.routesStore.getShipWaypointsCount > 0;
    },
    visible_cells_fields() {
      return [
        { key: "selected", label: this.$t("order.selected"), sortable: true, tdClass: "small-black", thClass: "small-gray" },
        { key: "id", label: this.$t("order.id"), sortable: true, tdClass: "small-black", thClass: "small-gray" },
        { key: "band", label: this.$t("order.band"), sortable: true, tdClass: "small-black", thClass: "small-gray" },
        { key: "price", label: this.$t("order.price"), sortable: true, tdClass: "small-black", thClass: "small-gray" },
      ];
    },
    visible_publications_fields() {
      return [
        { key: "selected", label: this.$t("order.selected"), tdClass: "small-black", thClass: "small-gray" },
        { key: "name", label: this.$t("order.id"), tdClass: "small-black", sortable: true, thClass: "small-gray" },
        { key: "price", label: this.$t("order.price"), tdClass: "small-black", thClass: "small-gray" },
      ];
    },
  },
  methods: {
    // === Методы для работы с компонентами ===

    // Обработчик изменения периода из PeriodStepper
    onPeriodChanged(newPeriod) {
      this.selectedPeriod = newPeriod;
      console.log("OrdersTable: Selected period changed to", this.selectedPeriod);
    },

    // Обработчик изменения фильтров из BandFilters
    onBandFiltersChanged(newFilters) {
      // Применяем изменения ко всем картам соответствующих бендов в корзине
      this.cartStore.getCart.forEach((item) => {
        const itemBand = this.extractBandFromMapId(item.id);
        let shouldBeDisabled = false;

        // Определяем новое состояние карты на основе фильтров
        switch (itemBand) {
          case 1: shouldBeDisabled = newFilters.filterOVR; break;
          case 2: shouldBeDisabled = newFilters.filterGNR; break;
          case 3: shouldBeDisabled = newFilters.filterCST; break;
          case 4: shouldBeDisabled = newFilters.filterAPR; break;
          case 5: shouldBeDisabled = newFilters.filterHRB; break;
          case 6: shouldBeDisabled = newFilters.filterBRG; break;
        }

        // Переключаем только если текущее состояние не соответствует новому
        const currentlyDisabled = item.disabled;
        if (currentlyDisabled !== shouldBeDisabled) {
          this.toggleCellInclusion(item.id, "switch");
        }
      });

      // Сбрасываем цены после изменения
      this.resetTotalPriceIfNeeded();
    },

    customSortBand(a, b, isDesc) {
      // Сортировка по usageBand (третий символ id как число)
      const bandA = parseInt(a.id?.charAt(2), 10) || 0;
      const bandB = parseInt(b.id?.charAt(2), 10) || 0;
      if (bandA < bandB) return isDesc ? 1 : -1;
      if (bandA > bandB) return isDesc ? -1 : 1;
      return 0;
    },

    // Методы для переключателя периодов
    importClipboard() {
      this.openCellsList = true;
    },

    async getCellsByRoute() {
      // this.cartStore.clear()
      this.performCartClear();

      let points = [];
      this.routesStore.getShipWaypoints.forEach((item) => {
        points.push({ lat: item.lat, lon: item.lon });
      });

      let provider;
      if (this.deviceStore.getAgreementProvider === "Primar" || this.deviceStore.getAgreementID === "-1") provider = ["Primar"];
      else provider = ["Unknown"];

      try {
        await loadDatasetByLegs(points, provider);
        let cellIds = this.momentaryStore.getChartsByRoute;

        console.log("getCellsByRoute: Processing", cellIds.length, "charts from route");

        // Используем новый метод с детальной статистикой
        const stats = await this.cartStore.addCellsWithStats(cellIds, true);

        // 🎨 Получаем только успешно добавленные ячейки
        const addedCellIds = this.cartStore.cart
          .filter((item, index, arr) =>
            index >= arr.length - stats.added) // Последние добавленные ячейки
          .map(item => item.id);

        // Отображаем ТОЛЬКО добавленные ячейки на карте (не включаем дубликаты и ошибки)
        addedCellIds.forEach((cellId) => {
          this.$emit("on-cell-clicked-orders-table", cellId);
        });

        this.markCellsAsNew(addedCellIds);

        // Показываем специализированное уведомление для маршрута
        this.showRouteChartsResults(stats, points.length);

      } catch (error) {
        console.error("Error during route charts selection:", error);
        this.$bvToast.toast("Error occurred while selecting charts by route", {
          title: "Route Charts Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
      }
    },

    selectChartsByRoute() {
      if (!this.hasActiveRoute) {
        this.$bvToast.toast("Please build a route first before selecting charts by route.", {
          title: "No Route Available",
          variant: "warning",
          solid: true,
          autoHideDelay: 4000,
        });
        return;
      }

      // Показываем подтверждающий диалог
      this.$bvModal
        .msgBoxConfirm("This will clear your current cart and select charts along the route. Continue?", {
          title: "Select Charts by Route",
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: "Yes, Select Charts",
          cancelTitle: "Cancel",
        })
        .then(async (value) => {
          if (value) {
            // Пользователь подтвердил - запускаем подбор карт по маршруту
            // eventBus.$emit('select-charts-by-route');
            await this.getCellsByRoute();

            this.$bvToast.toast("Selecting charts along the route...", {
              title: "Route Analysis",
              variant: "info",
              solid: true,
              autoHideDelay: 3000,
            });
          }
        });
    },

    toggleAreaSelection() {
      if (this.areaSelectionActive) {
        // Отменяем выбор области
        this.cancelAreaSelection();
      } else {
        // Активируем выбор области
        this.activateAreaSelection();
      }
    },

    activateAreaSelection() {
      console.log("selectMapArea called");

      this.areaSelectionActive = true;

      // Уведомляем пользователя о начале процесса с возможностью закрыть уведомление вручную
      this.areaSelectionToastId = this.$bvToast.toast(
        "Draw a rectangular area on the map to select charts. Click the button again to cancel.",
        {
          title: "Area Selection Active",
          variant: "info",
          solid: true,
          autoHideDelay: 6000,
          id: "area-selection-toast",
        }
      );

      // Активируем режим рисования прямоугольника на карте
      eventBus.$emit("activate-area-selection");

      // Подписываемся на событие завершения выбора области
      eventBus.$off("area-selection-complete");
      eventBus.$on("area-selection-complete", (bounds) => {
        this.handleAreaSelection(bounds);
      });

      // Подписываемся на событие отмены выбора области (например, ESC)
      eventBus.$off("area-selection-cancelled");
      eventBus.$on("area-selection-cancelled", () => {
        this.cancelAreaSelection();
      });
    },

    cancelAreaSelection() {
      console.log("Cancelling area selection");

      this.areaSelectionActive = false;

      // Скрываем уведомление если оно еще активно
      if (this.areaSelectionToastId) {
        this.$bvToast.hide("area-selection-toast");
        this.areaSelectionToastId = null;
      }

      // Отменяем режим рисования на карте
      eventBus.$emit("cancel-area-selection");

      // Отписываемся от событий
      eventBus.$off("area-selection-complete");
      eventBus.$off("area-selection-cancelled");

      // Показываем уведомление об отмене
      this.$bvToast.toast("Area selection cancelled", {
        title: "Cancelled",
        variant: "secondary",
        solid: true,
        autoHideDelay: 2000,
      });
    },

    async handleAreaSelection(bounds) {

      // Генерируем уникальный ID для этой операции (для логов)
      const operationId = `AREA_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

      // Сбрасываем состояние выбора области
      this.areaSelectionActive = false;

      // Скрываем уведомление о выборе области
      if (this.areaSelectionToastId) {
        this.$bvToast.hide("area-selection-toast");
        this.areaSelectionToastId = null;
      }

      // Вычисляем примерный размер области
      // const latDiff = Math.abs(bounds.north - bounds.south);
      // const lngDiff = Math.abs(bounds.east - bounds.west);

      try {
        // Показываем индикатор загрузки
        this.momentaryStore.startCriticalLoading("area-maps", "Searching for charts in selected area...");

        // Определяем провайдера для запроса
        const provider = this.deviceStore.getAgreementProvider;

        // Получаем карты по области

        const maps = await getMapsByArea(bounds, provider);


        // Добавляем карты в корзину
        const cartResult = await this.addMapsToCart(maps);

        // Убираем выделение области с карты
        eventBus.$emit("clear-area-selection");


        // Формируем сообщение с учетом ограничений
        let successMessage = `Found and added to cart: ${cartResult.addedCount} charts`;
        if (cartResult.originalCount > cartResult.addedCount) {
          successMessage += ` (limited from ${cartResult.originalCount} found)`;
        }

        this.$bvToast.toast(successMessage, {
          title: "Charts Added",
          variant: "success",
          solid: true,
          autoHideDelay: 4000,
        });
      } catch (error) {
        console.error(`[${operationId}] ❌ ERROR getting charts by area:`, error);

        // Сбрасываем состояние выбора области при ошибке
        this.areaSelectionActive = false;

        // Убираем выделение области с карты
        eventBus.$emit("clear-area-selection");

        this.$bvToast.toast("Error searching for charts in selected area", {
          title: "Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
      } finally {
        // Останавливаем индикатор загрузки
        this.momentaryStore.stopCriticalLoading("area-maps");

        // Отписываемся от событий
        eventBus.$off("area-selection-complete");
        eventBus.$off("area-selection-cancelled");
      }
    },

    async addMapsToCart(maps) {

      // Общая статистика карт
      const originalCounts = {
        avcs: maps.avcs?.length || 0
      };

      // Обрабатываем AVCS/ENC карты с ограничением и сортировкой
      let processedAvcs = [];

      if (maps.avcs && maps.avcs.length > 0) {
        // Очищаем ID карт
        const cleanedMapIds = maps.avcs.map((mapId) => mapId.trim());

        // Сортируем по бэндам (3-й символ в ID карты) по возрастанию
        const sortedMapIds = cleanedMapIds.sort((a, b) => {
          const bandA = this.extractBandFromMapId(a);
          const bandB = this.extractBandFromMapId(b);
          return bandA - bandB;
        });

        // Ограничиваем до 100 карт
        const maxMaps = 100;
        processedAvcs = sortedMapIds.slice(0, maxMaps);

        // Показываем предупреждение если карт было больше лимита
        if (sortedMapIds.length > maxMaps) {
          this.$bvToast.toast(
            `Too many charts selected! Only the first ${maxMaps} charts (sorted by band) were added to cart. Original count: ${sortedMapIds.length}`,
            {
              title: "Limit Applied",
              variant: "warning",
              solid: true,
              autoHideDelay: 6000,
            }
          );
          console.log(`[LIMIT] Reduced AVCS maps from ${sortedMapIds.length} to ${maxMaps}`);
        }
      }

      // Добавляем основные карты (AVCS/ENC) массово
      if (processedAvcs.length > 0) {

        // Используем метод addCells для массового добавления (ждем завершения)
        await this.cartStore.addCells(processedAvcs, true);

        // 🎨 Анимируем новые ячейки
        this.markCellsAsNew(processedAvcs);

        // Отправляем события для подсветки карт
        this.highlightMapsOnChart(processedAvcs);

      }

      // Принудительно обновляем Vue реактивность для корректного отображения таблицы
      await this.$nextTick();
      this.$forceUpdate();

      // Возвращаем информацию о количестве добавленных карт
      const result = {
        addedCount: processedAvcs.length,
        originalCount: originalCounts.avcs,
        limitApplied: originalCounts.avcs > processedAvcs.length,
      };

      return result;
    },

    // Метод для извлечения бэнда из ID карты (3-й символ)
    extractBandFromMapId(mapId) {
      try {
        // Бэнд находится в 3-м символе ID карты (индекс 2)
        if (mapId && mapId.length >= 3) {
          const bandChar = mapId.charAt(2);
          const band = parseInt(bandChar, 10);
          return isNaN(band) ? 9 : band; // Если не число, считаем как максимальный бэнд
        }
        return 9; // Если ID короткий, считаем как максимальный бэнд
      } catch (error) {
        console.warn("Error extracting band from map ID:", mapId, error);
        return 9; // В случае ошибки возвращаем максимальный бэнд
      }
    },

    // Оптимизированный метод для подсветки карт на карте
    highlightMapsOnChart(mapIds) {
      // Группируем карты по типу (простые и сложные) для оптимизации
      const simpleMapIds = [];
      const complexMapIds = [];

      mapIds.forEach((mapId) => {
        if (this.isComplexProduct(mapId)) {
          complexMapIds.push(mapId);
        } else {
          simpleMapIds.push(mapId);
        }
      });

      // Отправляем события пакетами для лучшей производительности
      if (simpleMapIds.length > 0) {
        console.log("[PERFORMANCE] Highlighting", simpleMapIds.length, "simple maps");

        // Для простых карт можем отправить массовое событие или по частям
        const chunkSize = 500; // Обрабатываем по 500 карт за раз
        for (let i = 0; i < simpleMapIds.length; i += chunkSize) {
          const chunk = simpleMapIds.slice(i, i + chunkSize);

          // Используем setTimeout для асинхронной обработки больших пакетов
          setTimeout(() => {
            chunk.forEach((mapId) => {
              this.$emit("on-cell-clicked-orders-table", mapId);
            });
          }, 0);
        }
      }

      if (complexMapIds.length > 0) {
        console.log("[PERFORMANCE] Highlighting", complexMapIds.length, "complex maps");

        // Для сложных карт также обрабатываем пакетами
        setTimeout(() => {
          complexMapIds.forEach((mapId) => {
            this.$emit("on-cell-clicked-complex-orders-table", mapId);
          });
        }, 0);
      }
    },
    clearCart() {
      // Показываем подтверждающий диалог
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to clear the cart? This action cannot be undone.", {
          title: "Clear Cart",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Clear",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            // Пользователь подтвердил очистку
            this.performCartClear();
          }
        })
        .catch((err) => {
          // Обрабатываем ошибку, если нужно
          console.log("Dialog error:", err);
        });
    },

    performCartClear() {
      try {
        // Очищаем анимации новых ячеек
        this.clearAllCellAnimations();

        // Очищаем всю корзину (основные карты и все цены)
        this.cartStore.clear();

        // Если активен режим маршрута, также очищаем данные маршрута
        if (this.hasActiveRoute) {
          this.momentaryStore.clearChartsByRoute();
          this.momentaryStore.setCellsByRoute([]);
          console.log("Route data cleared");
        }

        // Уведомляем карту об очистке выбранных элементов
        eventBus.$emit("clear-selected-cells");

        // Показываем уведомление об успешной очистке
        this.$bvToast.toast("Cart has been cleared", {
          title: "Cart Cleared",
          variant: "success",
          solid: true,
          autoHideDelay: 2000,
        });

        console.log("Cart cleared successfully");
      } catch (error) {
        console.error("Error clearing cart:", error);

        // Показываем уведомление об ошибке
        this.$bvToast.toast("Error clearing cart", {
          title: "Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 3000,
        });
      }
    },
    isEmptyCart() {
      // Проверяем есть ли активные товары в корзине любого типа
      const hasActiveMainItems = this.currentCartEnabledItemsLen > 0;

      // Корзина пустая если нет активных товаров ни одного типа
      return !hasActiveMainItems;
    },

    // Метод для проверки есть ли рассчитанная общая цена
    hasTotalPrice() {
      // Проверяем общую цену в корзине
      const hasMainPrice = this.cartStore.getTotalPrice !== undefined && this.cartStore.getTotalPrice !== 0;

      // Проверяем наличие активных товаров в корзине
      const hasActiveItems = this.currentCartEnabledItemsLen > 0


      // Если корзина пустая - цена не нужна
      if (!hasActiveItems) {
        return false;
      }

      console.log("hasTotalPrice: hasMainPrice =", hasMainPrice, ", currentCartEnabledItemsLen =", this.currentCartEnabledItemsLen);

      // Если есть основные товары - проверяем основную цену
      if (this.currentCartEnabledItemsLen > 0) {
        return hasMainPrice;
      }

      return false
    },

    // Метод для сброса общей цены при изменениях корзины
    resetTotalPriceIfNeeded() {
      this.cartStore.clearTotalPrice();
    },

    async primarMapBoosterByList() {
      this.openCellsList = false;
      let cells = this.cellList.split(/[\n,]/);

      // Добавляем импортированные ячейки в корзину и отображаем на карте
      const cellIds = cells.map((item) => item.trim()).filter((id) => id.length > 0);
      if (cellIds.length > 0) {
        console.log("primarMapBoosterByList: processing", cellIds.length, "cells");

        try {
          // Используем новый метод с детальной статистикой
          const stats = await this.cartStore.addCellsWithStats(cellIds, true);

          // 🎨 Получаем только успешно добавленные ячейки
          const addedCellIds = this.cartStore.cart
            .filter((item, index, arr) =>
              index >= arr.length - stats.added) // Последние добавленные ячейки
            .map(item => item.id);

          // Отображаем ТОЛЬКО добавленные ячейки на карте (не включаем дубликаты)
          addedCellIds.forEach((item) => {
            this.$emit("on-cell-clicked-orders-table", item);
          });

          this.markCellsAsNew(addedCellIds);

          // Показываем детальное уведомление о результатах импорта
          this.showDetailedImportResults(stats);

        } catch (error) {
          console.error("Error during cells import:", error);
          this.$bvToast.toast("Error occurred during import", {
            title: "Import Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          });
        }
      }
    },

    // Метод для отображения детальных результатов импорта
    showDetailedImportResults(stats) {
      const { totalRequested, added, notFound, duplicates, skipped } = stats;

      if (skipped === 0) {
        // Все ячейки успешно добавлены
        this.$bvToast.toast(`Successfully added all ${added} charts`, {
          title: "Import Completed",
          variant: "success",
          solid: true,
          autoHideDelay: 4000,
        });
      } else if (added === 0) {
        // Ни одна ячейка не добавлена
        let message = "No charts were added.";
        if (notFound.length > 0) {
          message += this.buildNotFoundMessage(notFound);
        }
        if (duplicates.length > 0) {
          message += `\nDuplicate charts: ${duplicates.join(', ')}`;
        }

        this.$bvToast.toast(message, {
          title: "Import Failed",
          variant: "danger",
          solid: true,
          autoHideDelay: 8000,
        });
      } else {
        // Частично успешный импорт
        let message = `Added ${added} charts successfully.`;

        if (notFound.length > 0) {
          message += this.buildNotFoundMessage(notFound);
        }

        if (duplicates.length > 0) {
          message += `\nSkipped ${duplicates.length} duplicate charts: ${duplicates.join(', ')}`;
        }

        this.$bvToast.toast(message, {
          title: "Import Partially Completed",
          variant: "warning",
          solid: true,
          autoHideDelay: 12000,
          toaster: 'b-toaster-top-right'
        });
      }

      console.log(`Import summary: ${added}/${totalRequested} charts added, ${skipped} skipped`);
      if (notFound.length > 0) {
        console.log("Charts not found in catalog:", notFound);
      }
      if (duplicates.length > 0) {
        console.log("Duplicate charts:", duplicates);
      }
    },

    /**
     * Построить сообщение об ошибке для карт не найденных в каталоге
     * Проверяет каждую карту в encreplaces и указывает замену если она есть
     */
    buildNotFoundMessage(notFoundIds) {
      if (!notFoundIds || notFoundIds.length === 0) {
        return '';
      }

      const replacedCharts = [];
      const reallyNotFound = [];

      // Проверяем каждую карту в encreplaces
      notFoundIds.forEach(chartId => {
        const replacement = this.catalogStore.getEncReplace(chartId);
        
        if (replacement) {
          // Карта найдена в replacements - это снятая с продажи карта
          replacedCharts.push({
            original: chartId,
            replace: replacement.replace,
            date: replacement.date || 'N/A',
            time: replacement.time || 'N/A'
          });
        } else {
          // Карта не найдена нигде
          reallyNotFound.push(chartId);
        }
      });

      let message = '';

      // Если есть замененные карты - показываем их с рекомендацией
      if (replacedCharts.length > 0) {
        message += ` Charts removed from sale and replaced:`;
        replacedCharts.forEach(chart => {
          const formattedDate = this.formatDateString(chart.date);
          message += ` • ${chart.original} → ${chart.replace} (removed: ${formattedDate})`;
        });
        message += ' Consider using the replacement charts instead.';
      }

      // Если есть реально не найденные карты - добавляем их
      if (reallyNotFound.length > 0) {
        if (replacedCharts.length > 0) {
          message += `\n\n`;
        }
        message += `\nCharts not found in catalog: ${reallyNotFound.join(', ')}`;
      }

      return message;
    },

    /**
     * Форматировать дату из строки YYYYMMDD в YYYY-MM-DD
     * Если дата невалидна или это 'N/A', возвращает исходное значение
     */
    formatDateString(dateStr) {
      if (!dateStr || dateStr === 'N/A') {
        return dateStr;
      }

      // Проверяем формат YYYYMMDD (8 символов, только цифры)
      if (dateStr.length === 8 && /^\d{8}$/.test(dateStr)) {
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        return `${year}-${month}-${day}`;
      }

      // Если уже в нужном формате, возвращаем как есть
      return dateStr;
    },

    // Метод для отображения результатов подбора ячеек по маршруту
    showRouteChartsResults(stats, waypointsCount) {
      const { totalRequested, added, notFound, duplicates, skipped } = stats;

      if (skipped === 0) {
        // Все ячейки успешно добавлены
        this.$bvToast.toast(
          `Successfully selected all ${added} charts for route with ${waypointsCount} waypoints`,
          {
            title: "Route Charts Selected",
            variant: "success",
            solid: true,
            autoHideDelay: 5000,
          }
        );
      } else if (added === 0) {
        // Ни одна ячейка не добавлена
        let message = `No charts were selected for the route with ${waypointsCount} waypoints.`;
        if (notFound.length > 0) {
          message += `\nCharts not found in catalog: ${notFound.join(', ')}`;
        }
        if (duplicates.length > 0) {
          message += `\nDuplicate charts: ${duplicates.join(', ')}`;
        }

        this.$bvToast.toast(message, {
          title: "Route Selection Failed",
          variant: "danger",
          solid: true,
          autoHideDelay: 8000,
        });
      } else {
        // Частично успешный подбор
        let message = `Selected ${added} charts for route with ${waypointsCount} waypoints.`;

        if (notFound.length > 0) {
          message += `\nSkipped ${notFound.length} charts not found in catalog: ${notFound.join(', ')}`;
        }

        if (duplicates.length > 0) {
          message += `\nSkipped ${duplicates.length} duplicate charts: ${duplicates.join(', ')}`;
        }

        this.$bvToast.toast(message, {
          title: "Route Charts Partially Selected",
          variant: "warning",
          solid: true,
          autoHideDelay: 10000,
          toaster: 'b-toaster-top-right'
        });
      }

      console.log(`Route charts summary: ${added}/${totalRequested} charts selected, ${skipped} skipped, waypoints: ${waypointsCount}`);
      if (notFound.length > 0) {
        console.log("Route charts not found in catalog:", notFound);
      }
      if (duplicates.length > 0) {
        console.log("Route duplicate charts:", duplicates);
      }
    },

    // Универсальный метод для добавления карт в корзину и отображения их на карте
    // Повторяет логику оригинального импорта primarMapBoosterByList
    async addCellsToCartAndMap(cellIds, append = false) {
      if (!cellIds || cellIds.length === 0) {
        console.warn("addCellsToCartAndMap: Список карт пустой");
        return;
      }

      console.log("addCellsToCartAndMap: Adding", cellIds.length, "charts, append:", append);

      try {
        // Используем новый метод с детальной статистикой
        const stats = await this.cartStore.addCellsWithStats(cellIds, append);

        // 🎨 Получаем только успешно добавленные ячейки
        const addedCellIds = this.cartStore.cart
          .filter((item, index, arr) =>
            index >= arr.length - stats.added) // Последние добавленные ячейки
          .map(item => item.id);

        // Отображаем ТОЛЬКО добавленные ячейки на карте (не включаем дубликаты)
        addedCellIds.forEach((cellId) => {
          this.$emit("on-cell-clicked-orders-table", cellId);
        });

        this.markCellsAsNew(addedCellIds);

        // Показываем детальное уведомление о результатах добавления
        this.showDetailedImportResults(stats);

        console.log("addCellsToCartAndMap: maps added to cart with stats:", stats);

      } catch (error) {
        console.error("Error during addCellsToCartAndMap:", error);
        this.$bvToast.toast("Error occurred during adding charts", {
          title: "Add Charts Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
      }
    },

    // Вызывается из родительского компонента при клике на ячейку
    getHistory() {
      return new Promise((resolve) => {
        if (!this.deviceStore.getDeviceID) {
          resolve();
          return;
        }

        this.momentaryStore.setBusy1(true);

        if (this.deviceStore.getAgreementProvider === "Primar") {
          // Используем только fallback прямо на primar-charts API
          console.log('[Orders] getHistory: запрашиваем прямо primar-charts');
          
          this.getPrimarChartsForOrders().then(chartsData => {
            console.log('[Orders] getHistory: успешно получены данные');
            this.momentaryStore.setBusy1(false);
            resolve(chartsData);
          }).catch(error => {
            console.error('[Orders] getHistory: ошибка при получении primar-charts:', error);
            this.momentaryStore.setBusy1(false);
            this.momentaryStore.setAPIError(true, "summary/deviceid");
            resolve({ orders: [] });
          });
        } else {
          console.warn("Unsupported agreement provider for history retrieval:", this.deviceStore.getAgreementProvider);
          this.momentaryStore.setBusy1(false);
        }
      });
    },

    /**
     * Загружаем fallback данные из primar-charts API для проверки купленных карт
     * Эти данные нужны чтобы при добавлении карты в корзину проверить, была ли она куплена
     */
    loadPrimarChartsDataForOrders() {
      if (!this.deviceStore.getDeviceID) {
        console.log('[Orders] loadPrimarChartsDataForOrders: нет deviceID');
        return;
      }

      const deviceId = this.deviceStore.getDeviceID;
      const URL = `https://mwend.bgeo.fi/api/v1/primar-charts/${deviceId}`;
      
      console.log('[Orders] loadPrimarChartsDataForOrders: запрашиваем fallback данные');
      
      myAxios.get(URL).then(resp => {
        if (resp.data.cells && Array.isArray(resp.data.cells)) {
          console.log('[Orders] loadPrimarChartsDataForOrders: загружено', resp.data.cells.length, 'карт');
          
          // Преобразуем в формат {name, expiryDate} для поиска
          const charts = resp.data.cells.map(cell => {
            let expiryDate = null;
            if (cell.exp) {
              // Используем dayjs для правильного форматирования даты без смещения временной зоны
              expiryDate = dayjs(cell.exp).format('YYYY-MM-DD');
            }
            return {
              name: cell.id,
              expiryDate: expiryDate
            };
          });
          
          this.deviceStore.addFallbackPrimarCharts(charts);
          console.log('[Orders] loadPrimarChartsDataForOrders: сохранено в store', charts.length, 'записей');
        } else {
          console.log('[Orders] loadPrimarChartsDataForOrders: нет поля cells в ответе');
        }
      }).catch(error => {
        console.warn('[Orders] loadPrimarChartsDataForOrders: ошибка при загрузке fallback:', error);
      });
    },

    /**
     * Получить данные Primar charts из API (fallback для orders)
     * Преобразует {cells: [...]} в {orders: [...]} формат для совместимости
     * Использует реальную дату окончания из поля exp (без добавления периода)
     */
    getPrimarChartsForOrders() {
      const deviceId = this.deviceStore.getDeviceID;
      const URL = `https://mwend.bgeo.fi/api/v1/primar-charts/${deviceId}`;
      
      console.log('[Orders] getPrimarChartsForOrders: запрашиваем fallback ручку:', URL);
      
      return new Promise((resolve, reject) => {
        myAxios.get(URL).then(resp => {
          console.log('[Orders] getPrimarChartsForOrders: ответ от fallback ручки:', resp.data);
          
          // Преобразуем результаты из primar-charts в формат orders
          const orders = [];
          
          if (resp.data.cells && Array.isArray(resp.data.cells)) {
            console.log('[Orders] getPrimarChartsForOrders: найдено карт:', resp.data.cells.length);
            
            resp.data.cells.forEach(cell => {
              // Для fallback данных НЕ вычисляем monthCount!
              // Используем только реальную дату окончания из API (exp)
              orders.push({
                id: `primar-charts-${cell.id}`,
                createdUtc: cell.exp || null, // реальная дата окончания от API
                status: 'complete',
                items: [
                  {
                    id: cell.id,
                    monthCount: 0, // Для fallback ставим 0 - период уже в exp дате!
                    price: 0,
                  }
                ],
                paymentMethod: '',
                expiryDays: null,
              });
            });
          } else {
            console.log('[Orders] getPrimarChartsForOrders: нет поля cells или это не массив');
          }
          
          console.log('[Orders] getPrimarChartsForOrders: преобразовано в', orders.length, 'заказов');
          resolve({ orders });
        }).catch(error => {
          console.error(`[Orders] getPrimarChartsForOrders: ошибка при запросе к fallback ручке для ${deviceId}:`, error);
          reject(error);
        });
      });
    },

    // Поиск покупки по ID ячейки
    findPurchasedById(id) {
      // Сначала проверяем в orderedData.primar.enc (из ship-folio или orders заказов)
      let historyStorage =
        this.deviceStore.getAgreementProvider === "Primar"
          ? this.deviceStore.orderedData.primar.enc
          : [];

      let purchased = historyStorage.find(e => e.name === id) || null;
      
      // Если не найдено, проверяем в fallback данных из store
      if (!purchased && this.deviceStore.fallbackPrimarCharts.length > 0) {
        purchased = this.deviceStore.fallbackPrimarCharts.find(e => e.name === id) || null;
      }
      
      return purchased;
    },

    // Покупалась ли карта ранее?
    purchasedEarly(id) {
      const purchased = this.findPurchasedById(id);
      if (!purchased) return false;
      
      // Проверяем что дата действия еще в будущем
      const validDate = purchased["expiryDate"];
      if (!validDate) return false;
      
      const expiryDate = dayjs(validDate);
      const now = dayjs();
      
      // Карта считается "купленной ранее" только если срок еще не истек
      return expiryDate.isAfter(now);
    },  

    // Если карта покупалась, возвращаем дату действия
    getCellValidDate(id) {
      const purchased = this.findPurchasedById(id);
      return purchased ? purchased["expiryDate"] : undefined;
    },

    getCurrency() {
      return this.deviceStore.getAgreementCurrency;
    },

    checkOrdersHistory() {
      let isNeedRecalculate = false;
      this.cartStore.getCart.forEach((item) => {
        // Если карта выбрана, но она еще валидна > 30 дней, снимаем выбор
        if (!item.disabled && this.deviceStore.isStillValid(item.id)) {
          console.log(`[OrdersTable] checkOrdersHistory: auto-deselecting ${item.id} as it is still valid`);
          this.toggleCellInclusion(item.id, 'off');
          isNeedRecalculate = true;
        }
      });

      if (isNeedRecalculate) {
        console.log('[OrdersTable] checkOrdersHistory: triggering price recalculation');
        this.resetTotalPriceIfNeeded();
      }
    },

    countTotalPrice() {
      if (this.cartStore.getCartLength === 0) {
        this.priceCalculating = false;
        return Promise.resolve();
      }

      this.priceCalculating = true;

      // Сбрасываем цены перед новым расчетом
      // this.resetTotalPriceIfNeeded()

      let deviceID = this.deviceStore.getDeviceID;
      let agreement = this.deviceStore.getAgreementID;
      let appType = this.userStore.getApplicationId(this.deviceStore.getDeviceID);
      let period = this.selectedPeriod;

      // alert("Calculating price for device: " + deviceID + ", agreement: " + agreement + ", appType: " + appType + ", period: " + period);

      console.log("Calculating price", deviceID, agreement, appType);

      // Получаем только включённые карты (не disabled) для расчета цены
      const enabledItems = this.cartStore.getCart.filter(item => !item.disabled);
      
      console.log("countTotalPrice: Full cart:", this.cartStore.getCart.map(item => ({ id: item.id, disabled: item.disabled })));
      console.log("countTotalPrice: Filtered enabled items:", enabledItems.map(item => ({ id: item.id, disabled: item.disabled })));
      console.log("Price calculation: sending", enabledItems.length, "enabled items out of", this.cartStore.getCartLength, "total");

      return this.cartStore
        .calculatePrice({
          products: enabledItems,
          periodBand: period,
          agreementID: agreement,
          deviceID: deviceID,
          appType: appType,
        })
        .catch((error) => {
          console.error("Error calculating price:", error);

          this.$bvToast.toast("Unable to calculate order cost, please try again later", {
            title: "Price Calculation Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          });
        })
        .finally(() => {
          this.priceCalculating = false;
        });
    },

    /**
     * Проверить наличие в корзине карт, которые были куплены ранее
     * и срок действия которых еще не истек, и остается более месяца
     * Возвращает массив таких карт - их не имеет смысла перекупать
     */
    findStillValidPreviouslyPurchasedCharts() {
      const stillValidCharts = [];

      this.cartStore.getCart.forEach((item) => {
        // Проверяем только выбранные (не disabled) карты
        if (!item.disabled) {
          // Проверяем через централизованную логику в store (валидность > 30 дней)
          if (this.deviceStore.isStillValid(item.id)) {
            const validDate = this.getCellValidDate(item.id);
            stillValidCharts.push({
              id: item.id,
              validDate: validDate,
              price: item.price
            });
          }
        }
      });

      return stillValidCharts;
    },

    /**
     * Показать предупреждение о наличии карт, которые еще актуальны
     */
    showStillValidChartsWarning(stillValidCharts) {
      const chartsList = stillValidCharts
        .map(chart => `• ${chart.id} (Valid till: ${chart.validDate})`)
        .join('\n');

      const message = `The following charts in your cart were previously purchased and are still valid for more than a month:\n\n${chartsList}\n\nPlease remove these charts from the cart if you do not want to purchase them again.`;

      this.$bvModal.msgBoxOk(message, {
        title: 'Charts Still Valid in Cart',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'warning',
        okTitle: 'OK',
        footerClass: 'p-3',
        hideHeaderClose: false,
        centered: true,
        bodyClass: 'p-3'
      });
    },

    placeOrder() {
      this.orderPlaced = true;
    },

    calculateCart() {
      // Проверяем наличие карт, которые еще актуальны перед расчетом цены
      const stillValidCharts = this.findStillValidPreviouslyPurchasedCharts();
      
      if (stillValidCharts.length > 0) {
        console.warn("Found still valid previously purchased charts:", stillValidCharts);
        this.showStillValidChartsWarning(stillValidCharts);
        return; // Прерываем выполнение, не продолжаем расчет
      }

      // Запускаем критическую загрузку для пересчета цен
      this.momentaryStore.startCriticalLoading("price-calculation", "Calculating prices...");

      // Рассчитываем все типы цен
      const promises = [];

      if (this.cartStore.getCartLength > 0) {
        promises.push(this.countTotalPrice());
      }

      // Ждем завершения всех расчетов и останавливаем критическую загрузку
      Promise.all(promises)
        .catch((error) => {
          console.error("Error in calculateCart:", error);
          // Ошибка уже обработана в countTotalPrice, здесь просто логируем
        })
        .finally(() => {
          this.momentaryStore.stopCriticalLoading("price-calculation");
        });
    },

    updateOrder() {
      this.orderPlaced = true;
    },

    cancelOrder() {
      this.orderPlaced = false;
    },

    onCellClicked(id) {
      alert("onCellClicked1 " + id);
      if (this.$refs.orderstable) {
        const row = this.$refs.orderstable.computedItems.findIndex((x) => x.id === id);
        console.log(id, row, this.items);
        this.$refs.orderstable.selectRow(row);
        // this.scrollToRow(row);//TODO
      }

      let cell = this.cartStore.getCart.find((o) => o.id === id);
      if (cell) {
        cell.disabled = false;
        this.highlightCell(id);
        // Сбрасываем общую цену при активации ячейки
        this.resetTotalPriceIfNeeded();
      }
    },

    approveOrder() {
      // Проверяем специальный случай для GMS Electronics Primar
      if (this.deviceStore.getAgreementName === "GMS Electronics Primar") {
        this.showGMSElectronicsDialog();
        return;
      }

      // Начинаем процесс подготовки заказа
      this.preparingCells = true;
      this.$parent.$parent.$parent.$parent.$parent.$parent.isDataLoading = true;

      let enabledItems = [];
      this.enabledCartItems().forEach((item) => {
        let enabledItem = {
          id: item.id,
          primarOrderTypeId: this.selectedPeriod,
          price: String(this.cartStore.getCellPrice(item.id)),
          monthCount: this.getDisplayPeriod(),
          type: this.deviceStore.getAgreementProvider === "Primar" ? "s63 maps" : "s63 maps",
        };
        enabledItems.push(enabledItem);
      });

      // Определяем метод оплаты
      let paymentMethod = this.deviceStore.getAgreementID !== "-1" ? "agreement" : "stripe";
      let comment = this.deviceStore.getAgreementProvider === "Primar" ? "Primar purchase by agreement" : "Stripe purchase";
      let data = {
        deviceId: this.deviceStore.getDeviceID,
        price: String(this.cartStore.getTotalPrice),
        items: enabledItems,
        comment: comment,
        paymentMethod: paymentMethod,
        currency: this.deviceStore.getAgreementCurrency,
        agreementId: this.deviceStore.getAgreementID,
        applicationTypeId: this.userStore.getApplicationId(this.deviceStore.getDeviceID),
        var: this.deviceStore.getAgreementProvider === "Primar" ? "primar" : "primar",
        domain: "ecdis-link.com",
      };

      if (this.viewParent.editMode) {
        // Режим редактирования заказа
        sendUpdateRequest(data.items, this.viewParent.orderId)
          .then(() => router.push({ name: "transactions", params: { qrevent: "reload-transactions" } }))
          .catch(() => router.push({ name: "transactions", params: { qrevent: "reload-transactions" } }));
      } else {
        // Создание нового заказа
        sendPurchaseRequest(data)
          .then((response) => {
            console.log("Purchase request response:", response);

            // Если используем Stripe оплату
            if (paymentMethod === "stripe") {
              // Получаем ID заказа из ответа
              const orderId = response; // Предполагаем, что сервер возвращает строку с ID заказа
              console.log("Order ID for Stripe payment:", orderId);

              // Отправляем запрос для получения URL оплаты
              return sendStripePaymentRequest(orderId)
                .then((stripeUrl) => {
                  console.log("Stripe payment URL:", stripeUrl);

                  // Открываем Stripe URL для оплаты
                  this.openStripePayment(stripeUrl);

                  // НЕ переходим к транзакциям сразу, пусть пользователь завершит оплату
                  // router.push({ name: "transactions", params: { qrevent: "reload-transactions" } });
                })
                .catch((error) => {
                  console.error("Error getting Stripe payment URL:", error);

                  this.$bvToast.toast("Error getting payment URL", {
                    title: "Payment Error",
                    variant: "danger",
                    solid: true,
                    autoHideDelay: 5000,
                  });

                  setTimeout(() => {
                    window.location.reload();
                  }, 5000);
                });
            } else {
              // Для оплаты по договору просто переходим к транзакциям
              router.push({ name: "transactions", params: { qrevent: "reload-transactions" } });
            }
          })
          .catch((error) => {
            console.error("Error creating order:", error);

            this.$bvToast.toast("Error creating order", {
              title: "Order Error",
              variant: "danger",
              solid: true,
              autoHideDelay: 5000,
            });

            setTimeout(() => {
              window.location.reload();
            }, 5000);

            // router.push({ name: "transactions", params: { qrevent: "reload-transactions" } });
          });
      }
    },

    // Метод для открытия окна оплаты Stripe
    openStripePayment(stripeUrl) {
      try {
        console.log("Opening Stripe payment URL:", stripeUrl);

        // Сразу пытаемся открыть новое окно без промежуточного диалога
        const stripeWindow = window.open(
          stripeUrl,
          "stripe-payment",
          "width=900,height=700,scrollbars=yes,resizable=yes,toolbar=yes,menubar=no,location=yes,status=yes"
        );

        // Проверяем, открылось ли окно
        if (stripeWindow) {
          // Окно успешно открыто
          console.log("Stripe payment window opened successfully");

          // Показываем уведомление об успешном открытии окна оплаты
          this.$bvToast.toast(
            "Payment window opened. Please complete the payment in the new window and return to this page.",
            {
              title: "Payment Window Opened",
              variant: "success",
              solid: true,
              autoHideDelay: 8000,
            }
          );

          // Пытаемся сфокусироваться на новом окне
          try {
            stripeWindow.focus();
          } catch (focusError) {
            console.warn("Could not focus on Stripe window:", focusError);
          }

        } else {
          // Окно заблокировано или не открылось
          console.warn("Stripe payment window was blocked or failed to open");

          this.$bvToast.toast(
            "Payment window was blocked by your browser.",
            {
              title: "Payment Window Blocked",
              variant: "warning",
              solid: true,
              autoHideDelay: 10000,
            }
          );

          // Показываем модальное окно с опциями оплаты
          this.showPaymentOptionsDialog(stripeUrl);
        }

      } catch (error) {
        console.error("Error opening Stripe payment:", error);

        // Показываем уведомление об ошибке
        this.$bvToast.toast("Error opening payment window", {
          title: "Payment Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });

        // Fallback: показываем ссылку в модальном окне
        this.$bvModal.msgBoxOk(
          `Please copy and paste this link into a new browser tab to complete payment:\n\n${stripeUrl}`,
          {
            title: "Payment Link",
            size: "lg",
            buttonSize: "sm",
            okVariant: "primary",
            okTitle: "Close",
            centered: true,
          }
        );
      }
    },

    // Метод для показа диалога с опциями оплаты при блокировке popup
    showPaymentOptionsDialog(stripeUrl) {
      this.$bvModal.msgBoxOk(
        `Your browser blocked the payment popup window.\n\nClick OK to continue to Stripe payment in this tab.\n\n(You will leave the current page)`,
        {
          title: "Payment Window Blocked",
          size: "md",
          buttonSize: "sm",
          okVariant: "warning",
          okTitle: "Continue to Payment",
          centered: true,
        }
      )
        .then(() => {
          // Пользователь нажал OK - открываем в том же окне
          console.log("User chose to open payment in same window");

          this.$bvToast.toast(
            "Redirecting to Stripe payment page...",
            {
              title: "Redirecting",
              variant: "info",
              solid: true,
              autoHideDelay: 3000,
            }
          );

          setTimeout(() => {
            window.location.href = stripeUrl;
          }, 1000);
        })
        .catch((error) => {
          console.error("Error in payment options dialog:", error);
        });
    },

    showGMSElectronicsDialog() {
      // Получаем список включенных карт
      const enabledItems = this.enabledCartItems();

      if (enabledItems.length === 0) {
        this.$bvToast.toast("No charts selected for export", {
          title: "Warning",
          variant: "warning",
          solid: true,
          autoHideDelay: 3000,
        });
        return;
      }

      const message = `Ship connected to this agreement (${this.deviceStore.getAgreementName}) purchases charts directly through dealer, please send them this charts list for purchase.`;


      // Показываем модальное окно с простым текстом
      this.$bvModal.msgBoxConfirm(message, {
        title: `Charts List - ${this.userStore.getShipName || 'Ship'}`,
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Get list',
        cancelVariant: 'secondary',
        cancelTitle: 'Close',
        footerClass: 'p-3',
        hideHeaderClose: false,
        centered: true,
        bodyClass: 'p-3'
      }).then((confirmed) => {
        if (confirmed) {
          // Кнопка "Get list" - сохраняем файл
          this.downloadChartsList(enabledItems);
        } else {
          // Кнопка "Close" - очищаем корзину и возвращаемся
          this.performCartClear();
          this.orderPlaced = false;
        }
      }).catch((err) => {
        console.error("Dialog error:", err);
      });
    },

    downloadChartsList(enabledItems) {
      try {
        // Получаем имя корабля и текущую дату
        const shipName = this.userStore.getShipName || 'Ship';
        const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD формат

        // Формируем содержимое файла
        const fileHeader = `Ship connected to this agreement (${this.deviceStore.getAgreementName}) purchases charts directly through dealer, please send them this chart list for purchase.\n\nOrder Date: ${currentDate}\nShip Name: ${shipName}\n\nCharts List:\n`;
        const chartsList = enabledItems.map(item => item.id).join('\n');
        const fileContent = fileHeader + chartsList;

        // Создаем blob и ссылку для скачивания
        const blob = new Blob([fileContent], { type: 'text/plain' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${shipName}_${currentDate}_charts.txt`;

        // Программно кликаем по ссылке для скачивания
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Освобождаем memory
        window.URL.revokeObjectURL(url);

        // Показываем уведомление об успешном скачивании
        this.$bvToast.toast(`Charts list saved as ${shipName}_${currentDate}_charts.txt`, {
          title: "File Downloaded",
          variant: "success",
          solid: true,
          autoHideDelay: 4000,
        });

        // Очищаем корзину и возвращаемся к заказу
        this.performCartClear();
        this.orderPlaced = false;

      } catch (error) {
        console.error("Error downloading charts list:", error);

        this.$bvToast.toast("Error downloading file", {
          title: "Error",
          variant: "danger",
          solid: true,
          autoHideDelay: 3000,
        });
      }
    },

    getCellDisplayPrice(id) {
      let price = this.cartStore.getCellPrice(id);
      if (price !== "?") {
        if (this.getCurrency() === "USD") price = "$" + price;
        else if (this.getCurrency() === "RUB") price = price + "₽";
        else price = price + "€"
      }
      return price;
    },

    getDisplayTotalPrice() {
      let price = this.cartStore.getTotalPrice;
      // alert(1)
      // alert(this.getCurrency())
      if (price !== 0) {
        if (this.getCurrency() === "USD") price = "$" + price;
        else if (this.getCurrency() === "RUB") price = price + "₽";
        else price = price + "€";
      }

      return price;
    },

    getDisplayPeriod() {
      if (this.selectedPeriod === "4") return "3";
      if (this.selectedPeriod === "1") return "6";
      if (this.selectedPeriod === "0") return "12";
    },

    toggleCellInclusion(id, type = "switch") {
      //      alert("toggleCellInclusion", id)
      
      // Унифицируем логику - при переключении через toggle эмулируем клик по ячейке на карте
      // Это обеспечивает синхронизацию с визуальным отображением на карте
      if (type === "switch") {
        console.log("toggleCellInclusion: Эмулируем клик по ячейке на карте для унификации логики", id);
        
        // Вместо прямого обновления store, эмулируем клик по ячейке
        // Это вызовет replaceCell() на карте, который правильно обновит визуальное состояние
        eventBus.$emit("cell-clicked", id);
        
        // Сбрасываем общую цену при изменении состояния ячейки
        this.resetTotalPriceIfNeeded();
      } else {
        // Для других типов используем прямой подход (резервный код)
        const isSelected = this.cartStore.updateCell({ id: id, type: type });

        const isComplex = this.isComplexProduct(id);

        if (isSelected) {
          if (!isComplex) this.$emit("on-cell-clicked-orders-table", id);
          else this.$emit("on-cell-clicked-complex-orders-table", id);
        } else {
          if (!isComplex) this.$emit("on-replace-cell-orders-table", id);
          else {
            this.$emit("on-cell-clicked-complex-orders-table", id);
            this.$emit("on-replace-cell-orders-table", id);
          }
        }
      }
    },

    bandName(code) {
      return utils.getBandName(code);
    },

    // Методы для анимации новых ячеек
    isNewlyAdded(cellId) {
      return this.newlyAddedCells.has(cellId);
    },

    getRowClass(item) {
      if (this.newlyAddedCells.has(item.id)) {
        return "newly-added-cell";
      }
      return "";
    },

    markCellsAsNew(cellIds) {
      if (!Array.isArray(cellIds)) {
        cellIds = [cellIds];
      }

      console.log("🎨 Marking cells as new:", cellIds);

      cellIds.forEach((cellId) => {
        // Добавляем в множество новых ячеек
        this.newlyAddedCells.add(cellId);

        // Очищаем предыдущий таймер если есть
        if (this.cellAnimationTimeouts.has(cellId)) {
          clearTimeout(this.cellAnimationTimeouts.get(cellId));
        }

        // Устанавливаем таймер для удаления анимации через 5 секунд
        const timeoutId = setTimeout(() => {
          this.newlyAddedCells.delete(cellId);
          this.cellAnimationTimeouts.delete(cellId);
          console.log("🎨 Removed animation for cell:", cellId);
        }, 5000);

        this.cellAnimationTimeouts.set(cellId, timeoutId);
      });

      // Принудительно обновляем таблицу для отображения анимации
      this.$forceUpdate();
    },

    clearAllCellAnimations() {
      // Очищаем все таймеры
      this.cellAnimationTimeouts.forEach((timeoutId) => {
        clearTimeout(timeoutId);
      });

      // Очищаем все данные анимации
      this.newlyAddedCells.clear();
      this.cellAnimationTimeouts.clear();

      console.log("🎨 Cleared all cell animations");
    },

    cellById(id) {
      return this.catalogsStore.getItemsById(id);
    },

    isComplexProduct(id) {
      return this.catalogsStore.isComplexProduct(id);
    },

    onRowSelected(items) {
      if (items.length > 0) {
        const selectedItem = items[0];
        const cellId = selectedItem.id;

        this.showCellOnMap(cellId, items);
      }
    },

    sortBands(a, b) {
      const bandA = this.cellById(a.id)?.usageBand ?? 0;
      const bandB = this.cellById(b.id)?.usageBand ?? 0;
      return bandA - bandB;
    },

    visibleCellsRows() {
      // Если есть активный маршрут, показываем карты по маршруту
      if (
        this.hasActiveRoute &&
        this.momentaryStore.getCellsByRoute &&
        this.momentaryStore.getCellsByRoute.length > 0
      ) {
        console.log(
          "📊 [ORDERS TABLE] visibleCellsRows: showing route cells",
          this.momentaryStore.getCellsByRoute.length
        );
        return this.momentaryStore.getCellsByRoute;
      }

      // Иначе показываем обычные карты из корзины - сортируем по бэндам без разворота
      const items = this.cartStore.getCart.slice().sort(this.sortBands);
      console.log("📊 [ORDERS TABLE] visibleCellsRows: showing cart cells", items.length, "items");
      console.log(
        "📊 [ORDERS TABLE] visibleCellsRows: cart items:",
        items.map((item) => item.id)
      );
      return items;
    },

    enabledCartItems() {
      const enabledItems = this.cartStore.getCart.filter(function (e) {
        return !e.disabled;
      });
      return enabledItems.slice().reverse();
    },

    highlightCellTemporary(id, customSettings = {}) {
      if (!id) {
        console.warn("Cannot highlight cell temporarily: ID is undefined or empty");
        return;
      }

      // Объединяем настройки по умолчанию с переданными параметрами
      const settings = {
        ...this.highlightSettings,
        ...customSettings,
        id: id,
      };

      // Отправляем событие для временной подсветки с анимацией
      eventBus.$emit("highlight-cell-temporary", settings);
    },

    highlightCell(id) {
      if (id) {
        // Проверяем, существует ли ячейка в корзине
        const cellExists = this.cartStore.getCart.some((item) => item.id === id);

        if (cellExists) {
          console.log("Highlighting cell with temporary white rectangle:", id);

          // Используем только нашу временную подсветку белым прямоугольником
          this.highlightCellTemporary(id, {
            color: "#ffffff", // Белый цвет для навигации
            opacity: 0.9,
            duration: 5000, // 5 секунд подсветки
            animationType: "pulse",
          });
        } else {
          console.warn("Cannot highlight cell: Cell with ID", id, "not found in cart");

          // Для ячеек не в корзине используем красную подсветку с временным прямоугольником
          this.highlightCellTemporary(id, {
            color: "#ff0000", // Красный цвет для предупреждения
            opacity: 0.7,
            duration: 3000, // 3 секунды предупреждения
            animationType: "flash",
          });
        }
      } else {
        console.warn("Cannot highlight cell: ID is undefined or empty");
      }
    },

    showCellOnMap(id, items) {
      if (!id) {
        console.warn("Cannot show cell on map: ID is undefined or empty");
        return;
      }

      console.log("showCellOnMap: show cell on map:", id);

      // Центрируем карту на ячейке (передаем items как в старом коде)
      eventBus.$emit("pane2cell", { id: id, items: items, color: "green" });
      const url = "https://win1hetz.bgeo.fi:5005/" + id + "/{z}/{x}/{y}";
      eventBus.$emit("show-cell-on-map", url);
    },
  },
};
</script>

<style scoped>
button:hover {
  color: black;
  background-color: white;
}

/* Добавляем gap между элементами */
.gap-1 {
  gap: 0.25rem;
}
</style>
